import { ApiCollections } from "@/api/collection";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useCollectionsData = () => {
  const { data: collections, isLoading } = useLocalizedQuery({
    queryKey: ["collections"],
    queryFn: async lang => ApiCollections.getCollections(lang),
  });

  return { collections, isLoading };
};
